import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer";
import CertificateVerification from "../CertificateVerification";
import Testimonials from "../Testimonials";
import FAQ from "../FooterPages/newfaq";
import AdvantagesSection from "./AdvantagesSection";
import VideoPlayer from "./VideoPlayer";
import WinnerCard from "./WinnerCard";
import styles from "./mentalmath.module.css";
import pmages from "../../assets/pmages.png";
// import flagPakistan from "../../assets/pakistan.png";
// import flagJapan from "../../assets/japan.png";
// import flagSaudiArabia from "../../assets/saudi_arabia.png";
// import flagNorway from "../../assets/norway.png";
// import flagUAE from "../../assets/united_arab_emirates.png";
// import flagUSA from "../../assets/united_states_of_america.png";
// import ss1 from "../../assets/ss1.png";
// import ss2 from "../../assets/ss2.png";
// import ss3 from "../../assets/ss3.png";
// import ss4 from "../../assets/ss4.png";
// import ss5 from "../../assets/ss5.png";
// import ss6 from "../../assets/ss6.png";
// import ss7 from "../../assets/ss7.png";
// import ss8 from "../../assets/ss8.png";
// import ss9 from "../../assets/ss9.png";
// import polygame from "../../assets/polygame.png";
// import polyglobal from "../../assets/polyglobal.png";
// import polylive from "../../assets/polylive.png";
// import polymaterial from "../../assets/polymaterial.png";
// import polyans from "../../assets/polyans.png";
// import polytop from "../../assets/polytop.png";
// import polystudent from "../../assets/polystudent.png";
// import polylearning from "../../assets/polylearning.png";
// import polytrophy from "../../assets/polytrophy.png";
import GallerySection from "../GallerySection";

const PolyProps = ({
  headerSection,
  upcomingCompetitionSection,
  competitionYearsSection,
  winnersSection,
  spotlightSection,
  text
}) => {
  const [selectedYear, setSelectedYear] = useState(
    competitionYearsSection?.years?.[0]?.year || competitionYearsSection?.defaultYear || 2024
  );
  const [dynamicWinningData, setDynamicWinningData] = useState([]);
  const navigate = useNavigate();

  // Update selectedYear when competitionYearsSection data changes (from database)
  useEffect(() => {
    if (competitionYearsSection?.years?.length > 0) {
      setSelectedYear(competitionYearsSection.years[0].year);
    }
  }, [competitionYearsSection?.years]);

  // Fetch dynamic winners when selectedYear or competitionId changes
  useEffect(() => {
    const selectedCompetition = competitionYearsSection?.years?.find(y => y.year === selectedYear);
    const competitionId = selectedCompetition?.competitionId;

    if (competitionId) {
      const apiEndpoint = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/students_results/${competitionId}`;
      fetch(apiEndpoint)
        .then(res => res.json())
        .then(response => {
          if (response.status === 'success' && response.data) {
            // Group and format for WinnerCard
            const formattedWinners = response.data.map(category => {
              // Get top 3 students (first one found for each rank to avoid breaking layout)
              const topStudents = [];
              [1, 2, 3].forEach(rank => {
                const student = category.participants.find(p => Number(p.rank) === rank);
                if (student) {
                  topStudents.push({
                    name: `${student.firstName || ''} ${student.lastName || ''}`.trim(),
                    rank: `${rank}${rank === 1 ? 'st' : rank === 2 ? 'nd' : 'rd'} Winner`,
                    country: student.country,
                    city: student.city,
                    age: student.age ? `${student.age} Years` : student.ages,
                    image: student.img
                  });
                }
              });

              return {
                year: selectedYear,
                ageCategory: category.displayName,
                studentsData: topStudents
              };
            }).filter(cat => cat.studentsData.length > 0);

            setDynamicWinningData(formattedWinners);
          } else {
            setDynamicWinningData([]);
          }
        })
        .catch(err => {
          console.error("Error fetching dynamic winners:", err);
          setDynamicWinningData([]);
        });
    } else {
      setDynamicWinningData([]);
    }
  }, [selectedYear, competitionYearsSection]);


  const advantages = [
    {
      imgSrc: 'Polymath-images/polygame.png',
      alt: "Gamified",
      title: "Gamified",
      text: "Makes learning fun and engaging through points, badges, and challenges.",
    },
    {
      imgSrc: 'Polymath-images/polyglobal.png',
      alt: "Global Access",
      title: "Global Access",
      text: "Students from any country can join and learn together.",
    },
    {
      imgSrc: 'Polymath-images/polylive.png',
      alt: "Live Quiz Competitions",
      title: "Live Quiz Competitions",
      text: "Students compete in real-time, making learning fun and fast-paced.",
    },
    {
      imgSrc: 'Polymath-images/polymaterial.png',
      alt: "Material Ready",
      title: "Material Ready",
      text: "All topics and syllabus provided.",
    },
    {
      imgSrc: 'Polymath-images/polyans.png',
      alt: "Answer Display",
      title: "Answer Display",
      text: "Understand better with shown solutions during competition.",
    },
    {
      imgSrc: 'Polymath-images/polytop.png',
      alt: "Top 3 Students Result",
      title: "Top 3 Students Result",
      text: "Live leaderboard shows top 3 students instantly after each competition.",
    },
    {
      imgSrc: 'Polymath-images/polystudent.png',
      alt: "Student Video Participation",
      title: "Student Video Participation",
      text: "Showcase learner interviews to boost confidence and engagement.",
    },
    {
      imgSrc: 'Polymath-images/polylearning.png',
      alt: "Learning Through Competition",
      title: "Learning Through Competition",
      text: "Students learn a lot in real-time as each competition reinforces understanding instantly.",
    },
    {
      imgSrc: 'Polymath-images/polytrophy.png',
      alt: "Trophies & Digital Certificates",
      title: "Trophies & Digital Certificates",
      text: "Earn rewards for outstanding progress.",
    },
  ];
  return (
    <>
      {/* Header Section (Props) */}
      <section className={styles.headerSection}>
        <div className={styles.headerContainer}>
          <img
            src={headerSection?.mainImage}
            alt="Main Image"
            className={styles.ppImg}
          />
          <div className={styles.headerSpacing}></div>
          <h1 className={styles.headerHeading}>
            <span className={styles.headingMain}>
              {headerSection?.mainHeading}
            </span>
            <br />
            <span className={styles.headingYears}>
              {headerSection?.subHeading}
            </span>
          </h1>

        </div>
        <img
          src={headerSection?.leftImage}
          alt="Left Image"
          className={styles.pc1Img}
        />
        <img
          src={headerSection?.rightImage}
          alt="Right Image"
          className={styles.pc2Img}
        />
        <p className={styles.pc1text}>{text || "Upcoming Events"}</p>
      </section>

      {/* Age Section (Static) */}
      <section className={styles.ageSection}>
        <div className={styles.ageSpacing}></div>
        <h2 className={styles.ageHeading}>
          <span className={styles.ageMain}>PolyMatch Age Categories – </span>
          <br />
          <span className={styles.ageSub}>Learn, Compete, and Grow</span>
        </h2>
        <div className={styles.ageSpacing}></div>
        <p className={styles.agePara}>
          PolyMatch competitions are thoughtfully designed for different age
          groups to ensure fair play and age-appropriate challenges. Each category
          features customized questions and tasks suited to the learning level of
          participants.
        </p>
        <div className={styles.ageSpacing}></div>
        <img
          src={pmages}
          alt="PolyMatch Age Categories"
          className={styles.pmagesImg}
        />
      </section>

      {/* Upcoming Competition Section (Props) */}
      <section className={styles.upcomingCompetitionSection}>
        <h2 className={styles.upcomingCompetitionHeading}>
          <span className={styles.upcomingCompetitionPart1}>
            {upcomingCompetitionSection?.mainHeading}
          </span>
          <br />
          <span className={styles.upcomingCompetitionPart2}>
            {upcomingCompetitionSection?.subHeading}
          </span>
        </h2>
        <h3 className={styles.globalScienceHeading}>
          {upcomingCompetitionSection?.competitionName}
        </h3>
        <p className={styles.globalScienceParagraph}>
          {upcomingCompetitionSection?.description}
        </p>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <a
          href={upcomingCompetitionSection?.registerLink}
          className={styles.registerBtn}
        >
          Click here to Register
        </a>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.flagsWrapper}>
          {upcomingCompetitionSection?.flags?.map((flag, index) => (
            <img
              key={index}
              src={flag.src}
              alt={flag.alt}
              className={styles.flagImage}
            />
          ))}
        </div>
      </section>

      {/* Advantages Section (Static) */}
      <AdvantagesSection
        advantages={advantages}
        heading={"Advantages of Participating in"}
        subheading={"PolyMatch Competitions"}
      />



      {/* Winners Section (Props) */}
      <section className={styles.winnersSection}>
        <div className={styles.winnersSpacing}></div>
        {/* <h2 className={styles.winnersHeading}>
          {winnersSection?.mainHeading}
        </h2> */}

        <div className={styles.competitionYearsSpacing}></div>
        <h3 className={styles.competitionYearTitle}>
          {
            competitionYearsSection?.years?.find(
              (y) => y.year === selectedYear
            )?.title
          }
        </h3>
        <div className={styles.competitionYearsSmallSpacing}></div>

        <h4 className={styles.competitionYearDates}>
          {
            competitionYearsSection?.years?.find(
              (y) => y.year === selectedYear
            )?.dates
          }
        </h4>
        <div className={styles.competitionTabsWrapper}>
          {competitionYearsSection?.years?.map((year) => (
            <div
              key={year.year}
              className={
                selectedYear === year.year
                  ? styles.competitionTabSelected
                  : styles.competitionTab
              }
              onClick={() => setSelectedYear(year.year)}
            >
              Competition {year.year}
            </div>
          ))}
        </div>


        <div className={styles.winnersSmallSpacing}></div>
        <div className={styles.winnersCardsContainer}>
          {(() => {
            const staticWinners = winnersSection?.winners?.filter((winner) => winner.year === selectedYear);
            const displayWinners = (staticWinners && staticWinners.length > 0) ? staticWinners : dynamicWinningData;
            return displayWinners?.map((winner, index) => (
              <WinnerCard key={index} winner={winner} />
            ));
          })()}
          <div className={styles.viewResultsContainer}>
            <button
              className={styles.viewResultsBtn}
              onClick={() => {
                const selectedCompetition = competitionYearsSection?.years?.find(y => y.year === selectedYear);
                const competitionId = selectedCompetition?.competitionId;
                const competitionName = selectedCompetition?.title;
                console.log("selectedCompetition:", selectedCompetition);
                navigate(`${winnersSection?.resultsLink}?year=${selectedYear}&competitionId=${competitionId}&competitionName=${competitionName}`);
              }}
            >
              Click to view Results
            </button>
          </div>
        </div>
        <div className={styles.winnersSmallSpacing}></div>
        <p className={styles.winnersPara}>
          {winnersSection?.description}
        </p>
      </section>



      {/* Competition Years Section (Props) */}

      <section className={styles.competitionYearsSection}>
        <div className={styles.competitionYearsSpacing}></div>
        {/* <h2 className={styles.competitionYearsHeading}>
          {competitionYearsSection?.mainHeading}
        </h2> */}
        {/* <div className={styles.competitionYearsSpacing}></div> */}

        <div className={styles.competitionYearsSmallSpacing}></div>
        <p className={styles.competitionYearPara}>
          {
            competitionYearsSection?.years?.find(
              (y) => y.year === selectedYear
            )?.description
          }
        </p>
        <div className={styles.competitionYearsSmallSpacing}></div>
        <div className={styles.flagsWrapper}>
          {competitionYearsSection?.flags?.map((flag, index) => (
            <img
              key={index}
              src={flag.src}
              alt={flag.alt}
              className={styles.flagImage}
            />
          ))}
        </div>
      </section>

      {/* Participant Spotlight Section (Props) */}
      <section className={styles.spotlightSection}>
        <div className={styles.spotlightSpacing}></div>
        <h2 className={styles.spotlightHeading}>
          <span className={styles.spotlightMain}>
            {spotlightSection?.mainHeading}
          </span>
          <span className={styles.spotlightSub}>
            {spotlightSection?.subHeading}
          </span>
        </h2>
        <div className={styles.spotlightSmallSpacing}></div>
        <p className={styles.spotlightPara}>
          {spotlightSection?.description}
        </p>
        <div className={styles.spotlightSmallSpacing}></div>
        <div className={styles.spotlightCardsRow}>
          {spotlightSection?.participants?.map((card, index) => (
            <div className={styles.spotlightCard} key={index}>
              <div className={styles.spotlightVideoPlaceholder}>
                <VideoPlayer videoUrl={card.video} />
              </div>
              <div className={styles.spotlightCardDetails}>
                <div className={styles.spotlightName}>{card.name}</div>
                <div className={styles.spotlightCompName}>{card.compName}</div>
                <div className={styles.spotlightRank}>{card.rank}</div>
                <div className={styles.spotlightCountry}>{card.country}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Certificate Verification (Static) */}
      {/* <CertificateVerification /> */}

      {/* Sponsors Section (Static) */}
      {/* <section className={styles.sponsorsSection}>
        <h2 className={styles.sponsorsHeading}>
          <span className={styles.sponsorsPart1}>Our Sponsors & </span>
          <br />
          <span className={styles.sponsorsPart2}>Strategic Partners</span>
        </h2>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.sponsorsGrid}>
          <div className={styles.sponsorItem}>
            <img src={ss1} alt="Sponsor 1" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss2} alt="Sponsor 2" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss3} alt="Sponsor 3" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss4} alt="Sponsor 4" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss5} alt="Sponsor 5" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss6} alt="Sponsor 6" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss7} alt="Sponsor 7" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss8} alt="Sponsor 8" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss9} alt="Sponsor 9" className={styles.sponsorImage} />
          </div>
        </div>
      </section> */}

      {/* Testimonials (Static) */}
      <Testimonials />

      {/* FAQ (Static) */}
      <FAQ />

      {/* Gallery Section (Static) */}
      {/* <section className={styles.gallerySection}>
        <div className={styles.container}>
          <div className={styles.galleryHeader}>
            <h2 className={styles.galleryTitle}>
              <span className={styles.galleryOf}>Gallery of </span>
              <span className={styles.learningGrowth}>Learning & Growth</span>
            </h2>
            <div className={styles.sunIcon}>
              <img src={require("../../assets/sun.png")} alt="Sun" />
            </div>
          </div>
          <div className={styles.galleryGrid}>
            {[...Array(8)].map((_, i) => (
              <div className={styles.galleryItem} key={i}>
                <img
                  src={
                    require(`../../assets/kid${i + 7}.png`) || "/placeholder.svg"
                  }
                  alt="Learning child"
                />
              </div>
            ))}
          </div>
          <div className={styles.calculatorIcon}>
            <img src={require("../../assets/calculator.png")} alt="Calculator" />
          </div>
          <div className={styles.galleryButton}>
            <a href="/gallery">
              <img
                src={require("../../assets/viewgallery.png")}
                alt="View Gallery"
              />
            </a>
          </div>
          <div style={{ height: '48px' }}></div>
        </div>
      </section> */}
      <div>
        <GallerySection />
      </div>

      {/* Footer (Static) */}
      <Footer />
    </>
  );
};

export default PolyProps;
